<template>
    <Icon
        :name="name"
        :width="width"
        :height="height"
        :color="color"
        fill-color="none"
        @click="$emit('click')"
    >
        <path
            class="a"
            d="M.75,23.25l6.53-5.224a3,3,0,0,1,2.2-.639l4.946.549a2.985,2.985,0,0,0,1.121-.087l7.7-2.1"
        />

        <path
            class="a"
            d="M.75,17.25l6.787-4.073a3,3,0,0,1,1.544-.427H14.35a3.007,3.007,0,0,0,1.242-.269L23.25,9"
        />

        <path
            class="a"
            d="M.75,11.25,8.8,7.226a3,3,0,0,1,1.993-.245L15,7.917a3,3,0,0,0,2.643-.686l5.6-4.981v21H.75V.75"
        />
    </Icon>
</template>

<script>
import Icon from '@/components/icons/Icon'

export default {
    name: 'AnalyticsGraphIcon',
    components: {
        Icon,
    },
    props: {
        name: {
            type: String,
            default: '',
        },
        width: {
            type: [Number, String],
            default: 18,
        },
        height: {
            type: [Number, String],
            default: 18,
        },
        color: {
            type: String,
            default: 'currentColor',
        },
    },
}
</script>

<style lang="scss" scoped>
.a {
    fill: none;
    stroke: currentColor;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-width: 1.5px;
}
</style>
